// extracted by mini-css-extract-plugin
export default {"form-change-password":"ChangePassword_form-change-password__uwxX-","button-change":"ChangePassword_button-change__Zt7SR"};